require("./dataTableExt.buttons.collection.js");
$.extend(
  !0,
  $.fn.dataTable.defaults,
  require("@/json/dataTable.defaults.json")
);
$.extend($.fn.dataTableExt.oSort, {
  "currency-pre": a => {
    a = a === "-" ? 0 : a.replace(/[^\d\-\.]/g, "");
    return parseFloat(a);
  },
  "currency-asc": (a, b) => a - b,
  "currency-desc": (a, b) => b - a
  // "numericnonempty-pre": a => {
  //   a = a.replace(/[^\d\-\.]/g, "");
  //   const val = a === "" ? "" : parseFloat(a);
  //   return val;
  // },
  // "numericnonempty-asc": (a, b) => {
  //   console.log("numericnonempty-asc");
  //   if (a === "") return 1; // Empty cells are considered greater
  //   if (b === "") return -1;
  //   return a - b;
  // },
  // "numericnonempty-desc": (a, b) => {
  //   console.log("numericnonempty-desc");
  //   if (a === "") return -1; // Empty cells are considered lower
  //   if (b === "") return 1;
  //   return b - a;
  // }
});



// WEBPACK FOOTER //
// ./src/script/datatables.extend.js